import {
  ICreateProjectTaskDTO,
  IServerResponse,
  IUpdateProjectTaskDTO,
  ProjectTask,
  ProjectTemplateTask,
} from '@aksia/models';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectTasksService {
  private projectsTasksUrl;
  private api = inject(CedricApiService);

  constructor() {
    this.projectsTasksUrl = 'ProjectTasks';
  }

  completeProjectTask(
    projectTask: Partial<ProjectTask>,
  ): Observable<IServerResponse> {
    const url = this.projectsTasksUrl + '/CompleteProjectTask';
    return this.api.post(url, projectTask);
  }

  createProjectTask(
    newProjectTask: ICreateProjectTaskDTO,
  ): Observable<ProjectTemplateTask & IServerResponse> {
    const url = this.projectsTasksUrl + '/CreateProjectTask';
    return this.api.post(url, newProjectTask);
  }

  updateProjectTask(
    projectTask: IUpdateProjectTaskDTO,
  ): Observable<IServerResponse> {
    const url = this.projectsTasksUrl + '/UpdateProjectTask';
    return this.api.post(url, { projectTask });
  }

  updateProjectTasks(
    projectTasks: Partial<ProjectTemplateTask>[],
  ): Observable<IServerResponse> {
    const url = this.projectsTasksUrl + '/UpdateProjectTasks';
    return this.api.post(url, { projectTasks });
  }

  updateProjectTasksOrder(
    projectTasksOrder: Partial<ProjectTemplateTask>[],
  ): Observable<IServerResponse> {
    const url = this.projectsTasksUrl + '/UpdateProjectTasksOrder';
    return this.api.post(url, { projectTasksOrder });
  }

  updateProjectTaskOrder(projectTaskReorder: any): Observable<IServerResponse> {
    const url = this.projectsTasksUrl + '/UpdateProjectTaskOrder';
    return this.api.post(url, projectTaskReorder);
  }

  cloneProjectTask(
    projectTask: any,
  ): Observable<ProjectTemplateTask & IServerResponse> {
    const url = this.projectsTasksUrl + '/CloneProjectTask';
    return this.api.post(url, projectTask);
  }
}
